import { useState } from "react";
import {
    IconButton, Button, Grid
} from "@material-ui/core";
import HeaderModal from "../../../global/headerModal";
import ModalBase from "../../../global/ModalBase";
import { FPagarItemStyle } from "./FPagarItemStyles";
import { useFormik } from "formik";
import * as yup from "yup";
import { ToastMessage } from "../../../global/ToastMessage";
import { DialogMessage } from "../../../global/DialogMessage";
import { useDispatch } from "react-redux";
import { obtenerExtrasAceptadasAction, pagarItemExtrraAction } from "../../../ducks/extrasContratadosAceptadasDuck"
import MoneyIcon from '@material-ui/icons/Money';
import { formatDinero } from "../../../utils/formatDinero"
import { FormatoFechaIso } from "../../../utils/FormatFecha";
import ButtonClienteDetalle from "../../../global/ButtonClienteDetalle";
import {offLoadAction, onLoadAnction} from "../../../ducks/loadDuck"
const validationSchema = yup.object({
    monto: yup
        .number("Ingresa un monto")
        .positive("Monto postivo")
        .required("Monto es requerido"),
});
const InitialValues = {
    monto: 1
}
const Formulario = (props) => {
    const {
        open = true,
        setOpen = () => { },
        Compra = {}
    } = props
    const dispatch = useDispatch()
    console.log("🚀 ~ Formulario ~ Compra:", Compra)
    const classes = FPagarItemStyle()
    const formik = useFormik({
        initialValues: InitialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSend(values)
        },
    })
    // const handleCancel = () => {
    //     DialogMessage.fire({
    //         title: '¿Esta seguro de marcar este item como cancelado?',
    //         text: '',
    //         showCancelButton: true,
    //         confirmButtonText: "Aceptar",
    //         cancelButtonText: "Cancelar",
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             dispatch(onLoadAnction({message: ''}))
    //             dispatch(cancelarCompraIndividual({
    //                 idCompra: Compra.idCompra,
    //             })).then(Response => {
    //                 dispatch(offLoadAction())
    //                 if (Response?.status === 500) {
    //                     ToastMessage.fire({
    //                         icon: "error",
    //                         title: "Ha habido un problema de conexión con el servidor",
    //                     });
    //                     return null
    //                 }
    //                 if (Response?.status === 400) {
    //                     ToastMessage.fire({
    //                         icon: "warning",
    //                         text: Response?.Message,
    //                     });
    //                     return null
    //                 }
    //                 handleClose();
    //                 dispatch(obtenerItemsIndividual())
    //                 ToastMessage.fire({
    //                     icon: "success",
    //                     title: "Ingreso Correcto",
    //                 });
    //             })
    //         }
    //     })
    // }
    const onSend = (values) => {
        DialogMessage.fire({
            title: '¿Esta seguro de marcar este item como pagado?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({message: ''}))
                dispatch(pagarItemExtrraAction({
                    idCompra: Compra.idCompra,
                })).then(Response => {
                    dispatch(offLoadAction())
                    if (Response?.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema de conexión con el servidor",
                        });
                        return null
                    }
                    if (Response?.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            text: Response?.Message,
                        });
                        return null
                    }
                    handleClose();
                    dispatch(obtenerExtrasAceptadasAction())
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            }
        })
    }

    const handleClose = () => {
        setOpen(false)
        formik.resetForm(InitialValues);
    }


    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
            <HeaderModal
                handleClose={handleClose}
                titulo="Pagar item extra"
            />
            <form onSubmit={formik.handleSubmit}>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12}>
                        <div style={{ display: "flex", flexFlow: "row", justifyContent: "center", alignItems: "flex-start", gap: "1rem" }}>
                            <div style={{ margin: '0 10px' }}>
                                <p>Referencia: <ButtonClienteDetalle referencia={`${Compra.meta.Referencia}`} /></p>
                                {
                                    (Compra.meta?.contratacion?.Cliente) &&
                                    <p>Cliente: <b>{`${Compra.meta?.contratacion?.Cliente}`}</b></p>
                                }
                                <p>Ahorro: <b>{`${formatDinero(Compra.paquete?.Cotizacion?.Suma)} ${Compra.paquete?.Cotizacion?.Moneda?.Clave}`}</b></p>
                                <p>Paquete: <b>{`${Compra.paquete?.Nombre}`}</b></p>
                                <p>Monto: <b>{`${formatDinero(Compra.paquete?.Monto_Paquete)} ${Compra.paquete?.Cotizacion?.Moneda?.Clave}`}</b></p>
                                <p>Fecha salida: <b>{`${FormatoFechaIso({ date: Compra.paquete?.Fecha_Viaje, formato: 'dd/MM/yyyy' })}`}</b></p>
                                <p>Fecha regreso: <b>{`${FormatoFechaIso({ date: Compra.paquete?.FechaRegreso, formato: 'dd/MM/yyyy' })}`}</b></p>
                                <p>No. Pax: <b>{`${Compra.paquete?.Numero_Personas}`}</b></p>
                            </div>
                            <div style={{ margin: '0 10px' }}>
                                <p>Motivo: <b>{`${Compra.TipoCompra?.Descripcion}`}</b></p>
                                <p>Operador: <b>{`${Compra.paquete?.Proveedor}`}</b></p>
                                <p>Monto proveedor: <b>{`${formatDinero(Compra.MontoProveedor)} ${Compra.paquete?.MonedaProveedor?.Clave}`}</b></p>
                                <p>Monto servicio: <b>{`${formatDinero(Compra.paquete?.PlanPago?.PlanPagosExtra?.MontoServicio)} ${Compra.paquete?.MonedaProveedor?.Clave}`}</b></p>
                                {
                                    (Compra.paquete?.PlanPago?.IdPlanPago <= 0) &&
                                    <p><b>Este extra se contrato antes </b> <br /> <b>del calculo de monto de servicio</b></p>
                                }

                            </div>
                        </div>
                    </Grid>
                </Grid>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                        >
                            Pagar
                        </Button>
                        {/* <Button
                            onClick={handleCancel}
                            variant="contained"
                            className={classes.modalBoton}
                        >
                            Cancelar compra
                        </Button> */}
                    </Grid>
                </Grid>
            </form>
        </ModalBase>
    )
}
const FPagarItemExtra = (props) => {
    const { Compra } = props
    const [open, setOpen] = useState(false)
    const onClick = () => {
        setOpen(true)
    }
    return (
        <div>
            <IconButton variant="outlined" onClick={onClick}>
                <MoneyIcon color="secondary" />
            </IconButton>
            <Formulario
                Compra={Compra}
                open={open}
                setOpen={setOpen}
            />
        </div>
    )
}
export default FPagarItemExtra
